// extracted by mini-css-extract-plugin
module.exports = {"star":"CollectStar_star__KoM7F"};